import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';
import './time-picker.scss';

export default class TimePicker extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.any,
    disabled: PropTypes.bool,
    inputRef: PropTypes.func,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.string
  };

  static defaultProps = {
    className: '',
    disabled: false,
    error: false,
    errorMessage: 'Please enter a valid time (e.g. 4:30 PM or 16:30)',
    inputRef: () => {},
    name: '',
    onBlur: () => {},
    onChange: () => {},
    placeholder: '',
    required: false,
    step: 60,
    type: 'time'
  };

  // Below is sort of a polyfill. On unsupported browsers, input[type='time'] falls back to
  // [type='text']. In that case we want to reformat any defaultValues from their ISO format
  // (e.g. '00:00:00.0000') to a readable string, so we use moment to achieve that.
  componentDidMount() {
    if (this.inputNode.type === 'text') {
      this.inputNode.defaultValue = moment(this.props.defaultValue, 'h:mm A').format('h:mm A');
    }
  }

  render() {
    const {label, error, errorMessage, inputRef, ...inputProps} = this.props;
    const inputClass = classnames('time-picker__input', {
      'time-picker__input--error': error
    });
    const errorContainer = error ? <div className='time-picker__error'>{errorMessage}</div> : null;
    return (
      <label className={`time-picker__wrapper ${this.props.className}`}>
        <div className='time-picker__label'>{label}</div>
        <input
          {...inputProps}
          className={inputClass}
          ref={(node) => {
            this.inputNode = node;
            inputRef(node);
          }}
        />
        {errorContainer}
      </label>
    );
  }
}
